import React from "react";

import {CategoryVariant} from "../components/CategoryVariant";

export const CategoryVariantPage = () => {
    return (
        <div>
            <CategoryVariant />
        </div>
    )
}